import ButtonLink from "plos/src/components/links/ButtonLink";
import { useTranslation } from "react-i18next";
import { ChevronRight } from "../../icons/Chevrons";
import { footnote } from "../entryInfo.css";
import EntryInfoPanel from "../EntryInfoPanel";
import MyLeagueCupSummary from "../MyLeagueCupSummary";
import { CupsPanelProps } from "./types";

const CupsPanel = ({
  hasCupLeagues,
  broadcasterCupLeagues,
  entry,
  filteredSystemCupLeagues,
  privateClassicCupLeagues,
  publicClassicCupLeagues,
}: CupsPanelProps) => {
  const { t } = useTranslation("leaguesAndCups");

  const headerAction = (
    <ButtonLink appearance="tonal" size="small" to="/leagues">
      {t("createJoinLeagues", "Create/Join Leagues")}
      <ChevronRight height={10} width={10} />
    </ButtonLink>
  );
  return (
    <EntryInfoPanel
      title={t("myCups.title", "My Cups")}
      headerAction={headerAction}
    >
      {hasCupLeagues && entry.id ? (
        <>
          {privateClassicCupLeagues.length > 0 && (
            <MyLeagueCupSummary
              entryId={entry.id}
              leagues={privateClassicCupLeagues.sort((a, b) =>
                a.name.localeCompare(b.name),
              )}
              title={t("privateLeagueCups", "League cups")}
            />
          )}
          {publicClassicCupLeagues.length > 0 && (
            <MyLeagueCupSummary
              entryId={entry.id}
              leagues={publicClassicCupLeagues}
              title={t("publicLeagueCups", "Public cups")}
            />
          )}
          {filteredSystemCupLeagues.length > 0 && (
            <MyLeagueCupSummary
              entryId={entry.id}
              leagues={filteredSystemCupLeagues}
              title={t("systemLeagueCups", "General cups")}
            />
          )}
          {broadcasterCupLeagues.length > 0 && (
            <MyLeagueCupSummary
              entryId={entry.id}
              leagues={broadcasterCupLeagues}
              title={t("broadcasterLeagueCups", "Broadcaster cups")}
            />
          )}
        </>
      ) : (
        <p className={footnote}>
          {t("leaguesNoCup", "None of your leagues have a cup yet.")}
        </p>
      )}
    </EntryInfoPanel>
  );
};

export default CupsPanel;
